import { createSlice } from "@reduxjs/toolkit";

export const abhaFormSteps = {
    AADHAR_FORM: 1,
    AADHAR_EMAIL_VERIFICATION: 2,
    ABHA_ADDRESS: 3,
};

const initialState = {
    currentStep: abhaFormSteps.AADHAR_FORM,
};

const abhaSlice = createSlice({
    name: "abha",
    initialState,
    reducers: {
        updateCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },
        updateAadharForm: (state, action) => {
            state.aadharForm = action.payload;
        },
        updateAadharEmailVerification: (state, action) => {
            state.aadharEmailVerification = action.payload;
        },
        updateAbhaAddress: (state, action) => {
            state.abhaAddress = action.payload;
        },
    },
});

export const selectCurrentStep = (state) => state.abha?.currentStep;
// Action creators are generated for each case reducer function
export const {
    updateCurrentStep,
    updateAadharForm,
    updateAadharEmailVerification,
    updateAbhaAddress,
} = abhaSlice.actions;

export const abhaReducer = abhaSlice.reducer;
